var SortButtonSortingDirection;

(function (SortButtonSortingDirection) {
  SortButtonSortingDirection[SortButtonSortingDirection["DESC"] = 0] = "DESC";
  SortButtonSortingDirection[SortButtonSortingDirection["ASC"] = 1] = "ASC";
})(SortButtonSortingDirection || (SortButtonSortingDirection = {}));

export { SortButtonSortingDirection };
//# sourceMappingURL=sort-button-constants.js.map
